import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuardService } from './infra/auth.guard';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { HomeComponent } from './pages/home/home.component';
import { StateListComponent } from './pages/state-list/state-list.component';
import { WeatherComponent } from './pages/weather/weather.component';
import { PlantListComponent } from './pages/plant-list/plant-list.component';
import { EnvironmentalComponent } from './pages/environmental/environmental.component';
import { YieldGuaranteeComponent } from './pages/yield-guarantee/yield-guarantee.component';

const routes: Routes = [
    // { path: 'login', component: LoginComponent },
    // { path: 'register', component: RegisterComponent },
    {
        path: '',
        component: DefaultLayoutComponent,
        // canActivate: [AuthGuardService],
        data: {
          title: 'Home',
        },
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: HomeComponent,
          },
          {
            path: 'state',
            component: StateListComponent,
          },
          {
            path: 'weather',
            component: WeatherComponent,
          },
          {
            path: 'plant/list',
            component: PlantListComponent,
          },
          {
            path: 'environmental',
            component: EnvironmentalComponent,
          },
          {
            path: 'yieldGuarantee',
            component: YieldGuaranteeComponent,
          },
        ]
    }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes)
    ],
    providers: [AuthGuardService],
    exports: [
    ],
})
export class AppRoutingModule { }
